export default __webpack_public_path__ + "static/media/binance_labs.fc6e6521.png";